export default __webpack_public_path__ + "static/media/Background.20c8548e.jpg";